import styled, { css } from 'styled-components';
import { MButtonIconState } from './MButtonIcon.types';

export const ButtonIcon = styled.button<{ state: MButtonIconState }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;

  ${({ state }) => {
    switch (state) {
      case MButtonIconState.Hover:
        return css`
          opacity: 0.8;
        `;
      case MButtonIconState.Active:
        return css`
          opacity: 0.6;
        `;
      case MButtonIconState.Disabled:
        return css`
          opacity: 0.4;
          cursor: not-allowed;
        `;
      default:
        return '';
    }
  }}
`;
